import { createAsyncThunk } from '@reduxjs/toolkit';

import { getUser } from '../../api/leaguesApi';
import config from '../../config';
import { isAccountNotVerifiedError } from '../../utils/emailVerification';

export const getAuthUser = createAsyncThunk('auth/getAuthUser', async () => {
    try {
        const res = await getUser();
        return res.data;
    } catch (err) {
        // An unverified email is not a sign-out: the session is still valid and the API instance's
        // interceptor has already sent the member to the verify screen, so do not open login over it.
        if (!isAccountNotVerifiedError(err)) {
            window.open(`${config.appHost}/login?redirect=${encodeURIComponent(window.location.href)}`, '_self');
        }
        const customError = {
            name: 'Axios Auth Error',
            message: err.response.data?.message || err.response.statusText,
        };
        throw customError;
    }
});
